import React, { createContext, useContext } from "react";
import TicketService from "../services/TicketService";
import useFetchData from "./useFetchData";


const TicketsContext = createContext();

export const TicketsProvider = ({ children, page = 1, pageSize = 1 }) => {
  const {
    data: tickets = [],
    isLoading,
    error,
  } = useFetchData(async () => {
    const ticketRequest = await TicketService.getTickets(1, 1);
    return ticketRequest?.data?.body?.tickets || [];
  }, []);

  return (
    <TicketsContext.Provider value={{ tickets, loading: isLoading, error }}>
      {children}
    </TicketsContext.Provider>
  );
};

export const useTickets = () => {
  const context = useContext(TicketsContext);
  if (context === undefined) {
    throw new Error("useTickets must be used within an TicketsProvider");
  }
  return context;
};
